import React from 'react';
import { FieldArray, FormikValues, useFormikContext } from 'formik';
import {
  Col,
  Row,
  AddButton,
  Responsive,
  FlexLayout,
  isDesktop as isDesktopHook,
} from '@gv/triage-components';

import { RemoveFieldButton } from 'components';

import * as Styles from '../../styles';

import { PhonesFieldArrayProps } from './types';

export const PhonesFieldArray = ({ name, label }: PhonesFieldArrayProps) => {
  const isDesktop = isDesktopHook();
  const { values } = useFormikContext<FormikValues>();

  const phones = values[name] as string[];
  const phonesCount = phones.length;
  const moreThenOnePhone = phonesCount > 1;

  return (
    <FieldArray
      name={name}
      render={({ push, remove }) => {
        return (
          <>
            {phones.map((_, index) => {
              const id = `${name}-${index}`;
              const isFirstField = index === 0;

              return (
                <Row key={id}>
                  <Col>
                    <FlexLayout
                      gap={8}
                      flexDirection={isDesktop ? 'row' : 'column'}
                    >
                      <Styles.InputField
                        type="tel"
                        name={`${name}.${index}`}
                        label={isFirstField ? label : undefined}
                      />

                      {moreThenOnePhone && (
                        <div>
                          {isFirstField && (
                            <Responsive.Desktop>
                              <p>&nbsp;</p>
                            </Responsive.Desktop>
                          )}

                          <RemoveFieldButton onClick={() => remove(index)} />
                        </div>
                      )}
                    </FlexLayout>
                  </Col>
                </Row>
              );
            })}

            <AddButton asRow text="Add new phone" onClick={() => push('')} />
          </>
        );
      }}
    />
  );
};
